import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useCustomQuestionGroupDelete(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionGroupDelete"],
    async (customQuestionGroupId: number) =>
      apiContext.customWorkflowQuestionApis.deleteCustomQuestionGroup(customQuestionGroupId),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
